import type { CaseResult } from '@/lib/smart-finder/types';

/** Build the shared opaque/indexed or field-based live-result tracking handoff. */
export function buildTrackCaseParams(
  caseResult: CaseResult,
  context: {
    indexedMatch: boolean;
    searchEventId?: string | null;
    logicalSearchId?: string | null;
  },
): URLSearchParams {
  const params = new URLSearchParams();

  // An index hit is only an identity observation, not a live status response.
  // Keep its full case/party payload out of redirects and let the authenticated
  // API resolve the opaque UUID from the server-owned index.
  if (context.indexedMatch) {
    if (caseResult.identity_id) params.set('identity_id', caseResult.identity_id);
  } else {
    if (caseResult.cnr_number) params.set('cnr', caseResult.cnr_number);
    if (caseResult.case_type) params.set('type', caseResult.case_type);
    if (caseResult.case_type_code) params.set('type_code', caseResult.case_type_code);
    if (caseResult.case_number) params.set('number', caseResult.case_number);
    if (caseResult.case_year) params.set('case_year', caseResult.case_year);
    if (caseResult.court_name) params.set('court', caseResult.court_name);
    if (caseResult.state) params.set('state', caseResult.state);
    if (caseResult.district) params.set('district', caseResult.district);
    if (caseResult.petitioner) params.set('petitioner', caseResult.petitioner);
    if (caseResult.respondent) params.set('respondent', caseResult.respondent);
    if (caseResult.status) params.set('case_status', caseResult.status);
    if (caseResult.next_hearing_date) params.set('next_hearing', caseResult.next_hearing_date);
    if (caseResult.diary_no) params.set('diary_no', caseResult.diary_no);
    if (caseResult.diary_year) params.set('diary_year', caseResult.diary_year);
    if (caseResult.hc_court_id) params.set('hc_court_id', caseResult.hc_court_id);
    if (caseResult.bench_code) params.set('bench_code', caseResult.bench_code);
  }

  if (context.searchEventId) params.set('search_event_id', context.searchEventId);
  if (context.logicalSearchId) params.set('logical_search_id', context.logicalSearchId);
  return params;
}
